import { useMemo } from 'react';
export function useInputHandlers(props) {
    const { onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress } = props;
    const handlers = useMemo(() => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (onBlur && { onBlur })), (onFocus && { onFocus })), (onKeyDown && { onKeyDown })), (onKeyUp && { onKeyUp })), (onKeyPress && { onKeyPress }))), [onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress]);
    return handlers;
}
export function useTextareaHandlers(props) {
    const { onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress } = props;
    const handlers = useMemo(() => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (onBlur && { onBlur })), (onFocus && { onFocus })), (onKeyDown && { onKeyDown })), (onKeyUp && { onKeyUp })), (onKeyPress && { onKeyPress }))), [onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress]);
    return handlers;
}
//# sourceMappingURL=handlers.js.map